export default [
	{
		modulo: 26,
		privilegio: 193,
		routerName: 'relatorio-abastecimento',
		routerPath: '/relatorio-abastecimento',
		componentName: 'RelatorioAbastecimento',
		componentPath: 'modules/layout/abastecimento/relatorio-abastecimento/main'
	},
	{
		modulo: 26,
		privilegio: 197,
		routerName: 'relatorio-preco-medio',
		routerPath: '/relatorio-preco-medio',
		componentName: 'RelatorioPrecoMedio',
		componentPath: 'modules/layout/abastecimento/relatorio-preco-medio/main'
	},
	{
		modulo: 26,
		privilegio: 197,
		routerName: 'relatorio-abastecimento-anual',
		routerPath: '/relatorio-abastecimento-anual',
		componentName: 'RelatorioAbastecimentoAnual',
		componentPath: 'modules/layout/abastecimento/relatorio-abastecimento-anual/main'
	},
	{
		modulo: 26,
		privilegio: 169,
		routerName: 'movimentacao-combustivel',
		routerPath: '/movimentacao-combustivel',
		componentName: 'MovimentacaoCombustivel',
		componentPath: 'modules/layout/abastecimento/movimentacao-combustivel/main'
	},
	{
		modulo: 26,
		privilegio: 197,
		routerName: 'relatorio-abastecimento-aeronave',
		routerPath: '/relatorio-abastecimento-aeronave',
		componentName: 'RelatorioAbastecimentoAeronave',
		componentPath: 'modules/layout/abastecimento/relatorio-abastecimento-aeronave/main'
	},
	{
		modulo: 26,
		privilegio: 197,
		routerName: 'relatorio-abastecimento-centro-custo',
		routerPath: '/relatorio-abastecimento-centro-custo',
		componentName: 'RelatorioAbastecimentoCentroCusto',
		componentPath: 'modules/layout/abastecimento/relatorio-abastecimento-centro-custo/main'
	}
]
